var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{staticClass:"block p-1 leading-0 rounded-full text-white bg-purple transition duration-150 ease-in-out cursor-pointer hover:bg-purple-light",attrs:{"role":"button"},on:{"click":_vm.click}},[_c('app-icon',{class:_vm.iconClasses,attrs:{"name":"settings-cog"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }